<div class="sui-indicator">
  @if (hasUnseen()) {
    <span class="sui-indicator-item sui-dot sui-dot-primary" aria-hidden="true"></span>
  }
  <button
    type="button"
    class="sui-btn sui-btn-sm sui-btn-icon"
    [class.sui-btn-ghost]="!helpOpen()"
    [class.sui-btn-primary]="helpOpen()"
    [attr.aria-pressed]="helpOpen()"
    [suiTooltip]="hasUnseen() ? 'Help — new product updates' : 'Help'"
    suiTooltipPlacement="bottom"
  >
    <i class="sui-icon sui-icon-question"></i>
  </button>
</div>
